namespace AgerLMS.Texts {

    export declare namespace Db {

        namespace Administration {

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace SiteSettings {
                export const SettingData: string;
                export const SettingId: string;
                export const SettingKey: string;
                export const SettingName: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const Bio: string;
                export const BirthDate: string;
                export const DisplayName: string;
                export const Email: string;
                export const EnableProfileMessages: string;
                export const Gender: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const JobTitle: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const ProfileCover: string;
                export const ProfileImage: string;
                export const Roles: string;
                export const Source: string;
                export const TcNo: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserGroup: string;
                export const UserId: string;
                export const UserImage: string;
                export const UserSettings: string;
                export const Username: string;
                export const ZoomApi: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace CMS {

            namespace CmsPage {
                export const Details: string;
                export const Header: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Keywords: string;
                export const PageHeader: string;
                export const PageId: string;
                export const PagePicture: string;
                export const PageRate: string;
                export const PageType: string;
                export const Seo: string;
                export const Summary: string;
            }

            namespace KeyImage {
                export const Description: string;
                export const Image: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Key: string;
                export const KeyImageId: string;
                export const OverrideImage: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace KeyValueSetting {
                export const Description: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Key: string;
                export const KeyValueSettingId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const Value: string;
            }

            namespace Slide {
                export const Description1: string;
                export const Description2: string;
                export const DisplayOrder: string;
                export const Header1: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Link1Href: string;
                export const Link1Text: string;
                export const Link2Href: string;
                export const Link2Text: string;
                export const Picture1: string;
                export const Picture1Meta: string;
                export const SlideId: string;
                export const SlideType: string;
                export const SliderId: string;
                export const SliderSliderName: string;
            }

            namespace Slider {
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const SliderId: string;
                export const SliderName: string;
                export const SliderType: string;
            }
        }

        namespace LMS {

            namespace Addresses {
                export const Address1: string;
                export const Address2: string;
                export const CityCode: string;
                export const CityId: string;
                export const CityName: string;
                export const DistrictCityId: string;
                export const DistrictCode: string;
                export const DistrictId: string;
                export const DistrictName: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Main: string;
                export const NeighbourhoodDistrictId: string;
                export const NeighbourhoodId: string;
                export const NeighbourhoodName: string;
                export const NeighbourhoodPostCode: string;
                export const Title: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserName: string;
            }

            namespace Badges {
                export const ConditionFrom: string;
                export const ConditionTo: string;
                export const Description: string;
                export const Id: string;
                export const Image: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PointReward: string;
                export const Title: string;
                export const Type: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Bundle {
                export const AccessPeriodDays: string;
                export const BundleDescription: string;
                export const BundleId: string;
                export const BundleName: string;
                export const BundleType: string;
                export const CategoryCategoryName: string;
                export const CategoryId: string;
                export const CategoryParentCategoryId: string;
                export const CoverImage: string;
                export const DemoVideo: string;
                export const DemoVideoSource: string;
                export const DisplayOrder: string;
                export const Downloadable: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Price: string;
                export const SalePrice: string;
                export const Seo: string;
                export const Thumbnail: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace BundleCourse {
                export const BundleBundleDescription: string;
                export const BundleBundleName: string;
                export const BundleId: string;
                export const CourseCourseDescription: string;
                export const CourseCourseName: string;
                export const CourseId: string;
                export const DisplayOrder: string;
                export const Duration: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
            }

            namespace BundleFilterItem {
                export const BundleBundleName: string;
                export const BundleId: string;
                export const FilterItemFilterId: string;
                export const FilterItemId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
            }

            namespace Cities {
                export const Code: string;
                export const Id: string;
                export const Name: string;
            }

            namespace Course {
                export const AccessPeriodDays: string;
                export const CategoryCategoryName: string;
                export const CategoryId: string;
                export const CategoryParentCategoryId: string;
                export const CourseDescription: string;
                export const CourseId: string;
                export const CourseName: string;
                export const CourseSectionCount: string;
                export const CourseType: string;
                export const CoverImage: string;
                export const DemoVideo: string;
                export const DemoVideoSource: string;
                export const DemoVideoUrl: string;
                export const Downloadable: string;
                export const Duration: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const InstructorId: string;
                export const InstructorName: string;
                export const IsActive: string;
                export const Prerequisites: string;
                export const Price: string;
                export const SalePrice: string;
                export const Seo: string;
                export const StudentCount: string;
                export const Thumbnail: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CourseContent {
                export const ContentType: string;
                export const CourseCourseName: string;
                export const CourseId: string;
                export const DisplayOrder: string;
                export const EntityId: string;
                export const EntityItemName: string;
                export const EntityType: string;
                export const HowManyWatched: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsUserCompleted: string;
                export const SectionId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CourseFilterItem {
                export const CourseCourseName: string;
                export const CourseId: string;
                export const FilterItemFilterId: string;
                export const FilterItemId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
            }

            namespace CoursePrerequisite {
                export const AffiliatedCourseCourseName: string;
                export const AffiliatedCourseId: string;
                export const CourseId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
            }

            namespace DetailMeta {
                export const DetailMeta: string;
                export const DetailMetaId: string;
                export const DetailMetaType: string;
                export const DisplayOrder: string;
                export const EntityId: string;
                export const EntityType: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace DiscountCategories {
                export const CategoryCategoryName: string;
                export const CategoryCategoryType: string;
                export const CategoryDisplayOrder: string;
                export const CategoryIcon25x25: string;
                export const CategoryId: string;
                export const CategoryInsertDate: string;
                export const CategoryInsertUserId: string;
                export const CategoryIsActive: string;
                export const CategoryParentCategoryId: string;
                export const CategorySeo: string;
                export const CategoryUpdateDate: string;
                export const CategoryUpdateUserId: string;
                export const DiscountCoupon: string;
                export const DiscountDiscountType: string;
                export const DiscountExpiryDate: string;
                export const DiscountGroups: string;
                export const DiscountId: string;
                export const DiscountInsertDate: string;
                export const DiscountInsertUserId: string;
                export const DiscountIsActive: string;
                export const DiscountMaxAmount: string;
                export const DiscountMinimumOrder: string;
                export const DiscountOnlyFirst: string;
                export const DiscountPercentage: string;
                export const DiscountProductType: string;
                export const DiscountSource: string;
                export const DiscountTitle: string;
                export const DiscountUpdateDate: string;
                export const DiscountUpdateUserId: string;
                export const DiscountUsableTimes: string;
                export const Id: string;
            }

            namespace DiscountCourses {
                export const CourseAccessPeriodDays: string;
                export const CourseCategoryId: string;
                export const CourseCourseDescription: string;
                export const CourseCourseName: string;
                export const CourseCoverImage: string;
                export const CourseDemoVideo: string;
                export const CourseDemoVideoSource: string;
                export const CourseDownloadable: string;
                export const CourseDuration: string;
                export const CourseId: string;
                export const CourseInsertDate: string;
                export const CourseInsertUserId: string;
                export const CourseInstructorId: string;
                export const CourseIsActive: string;
                export const CoursePrice: string;
                export const CourseSalePrice: string;
                export const CourseSeo: string;
                export const CourseSeoMetaDescription: string;
                export const CourseThumbnail: string;
                export const CourseUpdateDate: string;
                export const CourseUpdateUserId: string;
                export const DiscountCoupon: string;
                export const DiscountDiscountType: string;
                export const DiscountExpiryDate: string;
                export const DiscountGroups: string;
                export const DiscountId: string;
                export const DiscountInsertDate: string;
                export const DiscountInsertUserId: string;
                export const DiscountIsActive: string;
                export const DiscountMaxAmount: string;
                export const DiscountMinimumOrder: string;
                export const DiscountOnlyFirst: string;
                export const DiscountPercentage: string;
                export const DiscountProductType: string;
                export const DiscountSource: string;
                export const DiscountTitle: string;
                export const DiscountUpdateDate: string;
                export const DiscountUpdateUserId: string;
                export const DiscountUsableTimes: string;
                export const Id: string;
            }

            namespace DiscountGroups {
                export const DiscountCoupon: string;
                export const DiscountDiscountType: string;
                export const DiscountExpiryDate: string;
                export const DiscountGroupType: string;
                export const DiscountId: string;
                export const DiscountInsertDate: string;
                export const DiscountInsertUserId: string;
                export const DiscountIsActive: string;
                export const DiscountMaxAmount: string;
                export const DiscountMinimumOrder: string;
                export const DiscountOnlyFirst: string;
                export const DiscountPercentage: string;
                export const DiscountProductType: string;
                export const DiscountSource: string;
                export const DiscountTitle: string;
                export const DiscountUpdateDate: string;
                export const DiscountUpdateUserId: string;
                export const DiscountUsableTimes: string;
                export const Id: string;
            }

            namespace DiscountUsers {
                export const DiscountCoupon: string;
                export const DiscountDiscountType: string;
                export const DiscountExpiryDate: string;
                export const DiscountGroups: string;
                export const DiscountId: string;
                export const DiscountInsertDate: string;
                export const DiscountInsertUserId: string;
                export const DiscountIsActive: string;
                export const DiscountMaxAmount: string;
                export const DiscountMinimumOrder: string;
                export const DiscountOnlyFirst: string;
                export const DiscountPercentage: string;
                export const DiscountProductType: string;
                export const DiscountSource: string;
                export const DiscountTitle: string;
                export const DiscountUpdateDate: string;
                export const DiscountUpdateUserId: string;
                export const DiscountUsableTimes: string;
                export const Id: string;
                export const UserBio: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserEnableProfileMessages: string;
                export const UserGender: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserJobTitle: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserProfileCover: string;
                export const UserProfileImage: string;
                export const UserSource: string;
                export const UserTcNo: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserGroup: string;
                export const UserUserImage: string;
                export const UserUsername: string;
                export const UserZoomApi: string;
            }

            namespace Discounts {
                export const Categories: string;
                export const Coupon: string;
                export const Courses: string;
                export const DiscountType: string;
                export const ExpiryDate: string;
                export const Groups: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const MaxAmount: string;
                export const MinimumOrder: string;
                export const OnlyFirst: string;
                export const Percentage: string;
                export const ProductType: string;
                export const Source: string;
                export const Title: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UsableTimes: string;
            }

            namespace Districts {
                export const CityCode: string;
                export const CityId: string;
                export const CityName: string;
                export const Code: string;
                export const Id: string;
                export const Name: string;
            }

            namespace Faq {
                export const Answer: string;
                export const DisplayOrder: string;
                export const EntityId: string;
                export const EntityType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Question: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Filter {
                export const CategoryCategoryName: string;
                export const CategoryId: string;
                export const DisplayOrder: string;
                export const FilterId: string;
                export const FilterItems: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Title: string;
            }

            namespace FilterItem {
                export const FilterId: string;
                export const FilterTitle: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const OptionTitle: string;
            }

            namespace LMSComment {
                export const Comment: string;
                export const ConfirmDate: string;
                export const ConfirmUserId: string;
                export const EntityId: string;
                export const EntityItemName: string;
                export const EntityType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsReplied: string;
            }

            namespace Lesson {
                export const Accessibility: string;
                export const CourseCategoryId: string;
                export const CourseCourseDescription: string;
                export const CourseCourseName: string;
                export const CourseId: string;
                export const CoursePrice: string;
                export const CourseSalePrice: string;
                export const DisplayOrder: string;
                export const Downloadable: string;
                export const DripContent: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsUserCompleted: string;
                export const LessonDescription: string;
                export const LessonFileType: string;
                export const LessonName: string;
                export const LessonType: string;
                export const OriginalFileStreamUrl: string;
                export const OriginalFileUploadUrl: string;
                export const S3FileUploadUrl: string;
                export const SectionId: string;
                export const SectionSectionName: string;
                export const Seo: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const Volume: string;
            }

            namespace LmsCategory {
                export const CategoryId: string;
                export const CategoryName: string;
                export const CategoryType: string;
                export const CoverImage: string;
                export const Description: string;
                export const DisplayOrder: string;
                export const Icon25x25: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ParentCategoryCategoryName: string;
                export const ParentCategoryId: string;
                export const Seo: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace LmsDocument {
                export const Description: string;
                export const DisplayOrder: string;
                export const DocumentEntityType: string;
                export const DocumentName: string;
                export const DocumentType: string;
                export const EntityId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OnlineViewer: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace LmsPicture {
                export const DisplayOrder: string;
                export const EntityId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Picture: string;
                export const PictureEntityType: string;
            }

            namespace LmsReview {
                export const Comment: string;
                export const ConfirmDate: string;
                export const ConfirmUserId: string;
                export const EntityId: string;
                export const EntityItemName: string;
                export const EntityType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Rate1: string;
                export const Rate2: string;
                export const Rate3: string;
                export const Rate4: string;
            }

            namespace LmsSection {
                export const CourseCategoryId: string;
                export const CourseCourseDescription: string;
                export const CourseCourseName: string;
                export const CourseId: string;
                export const CoursePrice: string;
                export const CourseSalePrice: string;
                export const DisplayOrder: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const SectionContentCount: string;
                export const SectionDescription: string;
                export const SectionId: string;
                export const SectionName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace LmsTag {
                export const EntityId: string;
                export const EntityType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Tag: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Neighbourhoods {
                export const DistrictCityId: string;
                export const DistrictCode: string;
                export const DistrictId: string;
                export const DistrictName: string;
                export const Id: string;
                export const Name: string;
                export const PostCode: string;
            }

            namespace Order {
                export const ConfirmDate: string;
                export const ConfirmUserId: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const ItemCount: string;
                export const OrderGuid: string;
                export const OrderId: string;
                export const OrderState: string;
            }

            namespace OrderItem {
                export const AmountPaid: string;
                export const BundleCoverImage: string;
                export const BundleId: string;
                export const BundleThumbnail: string;
                export const CourseCoverImage: string;
                export const CourseId: string;
                export const CourseThumbnail: string;
                export const DeliveryFee: string;
                export const Discount: string;
                export const EntityId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const ItemCoverImage: string;
                export const ItemName: string;
                export const ItemPrice: string;
                export const ItemThumbnail: string;
                export const OrderConfirmDate: string;
                export const OrderConfirmUserId: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderItemEntityType: string;
                export const OrderOrderGuid: string;
                export const OrderOrderState: string;
                export const ProductCoverImage: string;
                export const ProductId: string;
                export const ProductThumbnail: string;
                export const Quantity: string;
                export const Tax: string;
                export const UsagePeriod: string;
                export const UserDisplayName: string;
                export const UserId: string;
            }

            namespace PricingPlan {
                export const Capacity: string;
                export const Discount: string;
                export const EndDate: string;
                export const EntityId: string;
                export const EntityItemName: string;
                export const EntityType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const PricingPlan: string;
                export const StartDate: string;
            }

            namespace Product {
                export const CategoryCategoryName: string;
                export const CategoryId: string;
                export const Commission: string;
                export const CoverImage: string;
                export const DeliveryEstimatedTime: string;
                export const DeliveryFee: string;
                export const DemoVideo: string;
                export const DisplayOrder: string;
                export const EnableOrdering: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Inventory: string;
                export const InventoryWarning: string;
                export const IsActive: string;
                export const Price: string;
                export const ProductDescription: string;
                export const ProductId: string;
                export const ProductSummary: string;
                export const ProductTitle: string;
                export const ProductType: string;
                export const SellerId: string;
                export const Seo: string;
                export const SeoMetaDescription: string;
                export const Tax: string;
                export const Thumbnail: string;
                export const UnlimitedInventory: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductFilterItem {
                export const FilterItemFilterId: string;
                export const FilterItemId: string;
                export const FilterItemInsertDate: string;
                export const FilterItemInsertUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const ProductId: string;
                export const ProductProductTitle: string;
            }

            namespace ProductSpecification {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const ProductId: string;
                export const ProductProductTitle: string;
                export const SpecificationId: string;
                export const SpecificationTitle: string;
            }

            namespace Quiz {
                export const CertificateIncluded: string;
                export const CorrectAnswerCount: string;
                export const CourseCourseName: string;
                export const CourseId: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const NumberOfAttemps: string;
                export const PassMark: string;
                export const QuestionCount: string;
                export const QuizEndDate: string;
                export const QuizId: string;
                export const QuizStartDate: string;
                export const QuizStatus: string;
                export const QuizTitle: string;
                export const SectionId: string;
                export const SectionSectionName: string;
                export const Time: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserGrade: string;
            }

            namespace QuizQuestion {
                export const ChoiceA: string;
                export const ChoiceB: string;
                export const ChoiceC: string;
                export const ChoiceD: string;
                export const ChoiceE: string;
                export const CorrectAnswer: string;
                export const DisplayOrder: string;
                export const Grade: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const Question: string;
                export const QuizCourseId: string;
                export const QuizId: string;
                export const QuizIsActive: string;
                export const QuizNumberOfAttemps: string;
                export const QuizPassMark: string;
                export const QuizQuizTitle: string;
                export const QuizSectionId: string;
                export const QuizTime: string;
            }

            namespace Specification {
                export const InputType: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const SpecificationId: string;
                export const Title: string;
            }

            namespace SpecificationCategory {
                export const CategoryCategoryName: string;
                export const CategoryId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const SpecificationId: string;
                export const SpecificationTitle: string;
            }

            namespace SpecificationItem {
                export const Id: string;
                export const InputValue: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const SpecificationId: string;
                export const SpecificationTitle: string;
            }
        }

        namespace Logging {

            namespace LessonWatchLog {
                export const AuthToken: string;
                export const CourseName: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IpNumber: string;
                export const LastSecond: string;
                export const LessonCourseId: string;
                export const LessonId: string;
                export const LessonLessonDescription: string;
                export const LessonLessonName: string;
                export const LessonLessonType: string;
                export const TotalSecond: string;
                export const UserAgent: string;
            }

            namespace LmsNotification {
                export const Description: string;
                export const Id: string;
                export const InsertDate: string;
                export const IsRead: string;
                export const NotificationType: string;
                export const RelatedUserDisplayName: string;
                export const RelatedUserId: string;
            }

            namespace SmsSendLog {
                export const Id: string;
                export const PhoneNumber: string;
                export const RelatedEntityId: string;
                export const RelatedEntityType: string;
                export const SendDate: string;
                export const SendSmsType: string;
                export const SenderUserId: string;
                export const SmsMessage: string;
                export const SmsMessageId: string;
                export const SmsResponse: string;
                export const SmsState: string;
                export const UserId: string;
            }

            namespace UserActivity {
                export const AuthToken: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IpNo: string;
                export const UserActivityType: string;
                export const UserAgent: string;
                export const UserDisplayName: string;
                export const UserId: string;
                export const UserUsername: string;
            }

            namespace UserEventLog {
                export const EntityId: string;
                export const EntityItemName: string;
                export const EntityType: string;
                export const EventType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IpNumber: string;
            }

            namespace UserQuizAnswer {
                export const Attempt: string;
                export const AuthToken: string;
                export const CorrectAnswer: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserDisplayName: string;
                export const InsertUserId: string;
                export const IpNumber: string;
                export const Question: string;
                export const QuestionChoiceA: string;
                export const QuestionChoiceB: string;
                export const QuestionChoiceC: string;
                export const QuestionChoiceD: string;
                export const QuestionChoiceE: string;
                export const QuestionCorrectAnswer: string;
                export const QuestionGrade: string;
                export const QuestionId: string;
                export const QuestionQuizId: string;
                export const UserAnswer: string;
            }
        }
    }

    export declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    export declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    export declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    export declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    AgerLMS['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{Language:{Id:1,LanguageId:1,LanguageName:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},SiteSettings:{SettingData:1,SettingId:1,SettingKey:1,SettingName:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{Bio:1,BirthDate:1,DisplayName:1,Email:1,EnableProfileMessages:1,Gender:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,JobTitle:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,ProfileCover:1,ProfileImage:1,Roles:1,Source:1,TcNo:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserGroup:1,UserId:1,UserImage:1,UserSettings:1,Username:1,ZoomApi:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},CMS:{CmsPage:{Details:1,Header:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Keywords:1,PageHeader:1,PageId:1,PagePicture:1,PageRate:1,PageType:1,Seo:1,Summary:1},KeyImage:{Description:1,Image:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,Key:1,KeyImageId:1,OverrideImage:1,UpdateDate:1,UpdateUserId:1},KeyValueSetting:{Description:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,Key:1,KeyValueSettingId:1,UpdateDate:1,UpdateUserId:1,Value:1},Slide:{Description1:1,Description2:1,DisplayOrder:1,Header1:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Link1Href:1,Link1Text:1,Link2Href:1,Link2Text:1,Picture1:1,Picture1Meta:1,SlideId:1,SlideType:1,SliderId:1,SliderSliderName:1},Slider:{InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,SliderId:1,SliderName:1,SliderType:1}},LMS:{Addresses:{Address1:1,Address2:1,CityCode:1,CityId:1,CityName:1,DistrictCityId:1,DistrictCode:1,DistrictId:1,DistrictName:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,Main:1,NeighbourhoodDistrictId:1,NeighbourhoodId:1,NeighbourhoodName:1,NeighbourhoodPostCode:1,Title:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserName:1},Badges:{ConditionFrom:1,ConditionTo:1,Description:1,Id:1,Image:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,PointReward:1,Title:1,Type:1,UpdateDate:1,UpdateUserId:1},Bundle:{AccessPeriodDays:1,BundleDescription:1,BundleId:1,BundleName:1,BundleType:1,CategoryCategoryName:1,CategoryId:1,CategoryParentCategoryId:1,CoverImage:1,DemoVideo:1,DemoVideoSource:1,DisplayOrder:1,Downloadable:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,Price:1,SalePrice:1,Seo:1,Thumbnail:1,UpdateDate:1,UpdateUserId:1},BundleCourse:{BundleBundleDescription:1,BundleBundleName:1,BundleId:1,CourseCourseDescription:1,CourseCourseName:1,CourseId:1,DisplayOrder:1,Duration:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1},BundleFilterItem:{BundleBundleName:1,BundleId:1,FilterItemFilterId:1,FilterItemId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1},Cities:{Code:1,Id:1,Name:1},Course:{AccessPeriodDays:1,CategoryCategoryName:1,CategoryId:1,CategoryParentCategoryId:1,CourseDescription:1,CourseId:1,CourseName:1,CourseSectionCount:1,CourseType:1,CoverImage:1,DemoVideo:1,DemoVideoSource:1,DemoVideoUrl:1,Downloadable:1,Duration:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,InstructorId:1,InstructorName:1,IsActive:1,Prerequisites:1,Price:1,SalePrice:1,Seo:1,StudentCount:1,Thumbnail:1,UpdateDate:1,UpdateUserId:1},CourseContent:{ContentType:1,CourseCourseName:1,CourseId:1,DisplayOrder:1,EntityId:1,EntityItemName:1,EntityType:1,HowManyWatched:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,IsUserCompleted:1,SectionId:1,UpdateDate:1,UpdateUserId:1},CourseFilterItem:{CourseCourseName:1,CourseId:1,FilterItemFilterId:1,FilterItemId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1},CoursePrerequisite:{AffiliatedCourseCourseName:1,AffiliatedCourseId:1,CourseId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1},DetailMeta:{DetailMeta:1,DetailMetaId:1,DetailMetaType:1,DisplayOrder:1,EntityId:1,EntityType:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,UpdateDate:1,UpdateUserId:1},DiscountCategories:{CategoryCategoryName:1,CategoryCategoryType:1,CategoryDisplayOrder:1,CategoryIcon25x25:1,CategoryId:1,CategoryInsertDate:1,CategoryInsertUserId:1,CategoryIsActive:1,CategoryParentCategoryId:1,CategorySeo:1,CategoryUpdateDate:1,CategoryUpdateUserId:1,DiscountCoupon:1,DiscountDiscountType:1,DiscountExpiryDate:1,DiscountGroups:1,DiscountId:1,DiscountInsertDate:1,DiscountInsertUserId:1,DiscountIsActive:1,DiscountMaxAmount:1,DiscountMinimumOrder:1,DiscountOnlyFirst:1,DiscountPercentage:1,DiscountProductType:1,DiscountSource:1,DiscountTitle:1,DiscountUpdateDate:1,DiscountUpdateUserId:1,DiscountUsableTimes:1,Id:1},DiscountCourses:{CourseAccessPeriodDays:1,CourseCategoryId:1,CourseCourseDescription:1,CourseCourseName:1,CourseCoverImage:1,CourseDemoVideo:1,CourseDemoVideoSource:1,CourseDownloadable:1,CourseDuration:1,CourseId:1,CourseInsertDate:1,CourseInsertUserId:1,CourseInstructorId:1,CourseIsActive:1,CoursePrice:1,CourseSalePrice:1,CourseSeo:1,CourseSeoMetaDescription:1,CourseThumbnail:1,CourseUpdateDate:1,CourseUpdateUserId:1,DiscountCoupon:1,DiscountDiscountType:1,DiscountExpiryDate:1,DiscountGroups:1,DiscountId:1,DiscountInsertDate:1,DiscountInsertUserId:1,DiscountIsActive:1,DiscountMaxAmount:1,DiscountMinimumOrder:1,DiscountOnlyFirst:1,DiscountPercentage:1,DiscountProductType:1,DiscountSource:1,DiscountTitle:1,DiscountUpdateDate:1,DiscountUpdateUserId:1,DiscountUsableTimes:1,Id:1},DiscountGroups:{DiscountCoupon:1,DiscountDiscountType:1,DiscountExpiryDate:1,DiscountGroupType:1,DiscountId:1,DiscountInsertDate:1,DiscountInsertUserId:1,DiscountIsActive:1,DiscountMaxAmount:1,DiscountMinimumOrder:1,DiscountOnlyFirst:1,DiscountPercentage:1,DiscountProductType:1,DiscountSource:1,DiscountTitle:1,DiscountUpdateDate:1,DiscountUpdateUserId:1,DiscountUsableTimes:1,Id:1},DiscountUsers:{DiscountCoupon:1,DiscountDiscountType:1,DiscountExpiryDate:1,DiscountGroups:1,DiscountId:1,DiscountInsertDate:1,DiscountInsertUserId:1,DiscountIsActive:1,DiscountMaxAmount:1,DiscountMinimumOrder:1,DiscountOnlyFirst:1,DiscountPercentage:1,DiscountProductType:1,DiscountSource:1,DiscountTitle:1,DiscountUpdateDate:1,DiscountUpdateUserId:1,DiscountUsableTimes:1,Id:1,UserBio:1,UserDisplayName:1,UserEmail:1,UserEnableProfileMessages:1,UserGender:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserJobTitle:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserProfileCover:1,UserProfileImage:1,UserSource:1,UserTcNo:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserGroup:1,UserUserImage:1,UserUsername:1,UserZoomApi:1},Discounts:{Categories:1,Coupon:1,Courses:1,DiscountType:1,ExpiryDate:1,Groups:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,MaxAmount:1,MinimumOrder:1,OnlyFirst:1,Percentage:1,ProductType:1,Source:1,Title:1,UpdateDate:1,UpdateUserId:1,UsableTimes:1},Districts:{CityCode:1,CityId:1,CityName:1,Code:1,Id:1,Name:1},Faq:{Answer:1,DisplayOrder:1,EntityId:1,EntityType:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,Question:1,UpdateDate:1,UpdateUserId:1},Filter:{CategoryCategoryName:1,CategoryId:1,DisplayOrder:1,FilterId:1,FilterItems:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Title:1},FilterItem:{FilterId:1,FilterTitle:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,OptionTitle:1},LMSComment:{Comment:1,ConfirmDate:1,ConfirmUserId:1,EntityId:1,EntityItemName:1,EntityType:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsReplied:1},Lesson:{Accessibility:1,CourseCategoryId:1,CourseCourseDescription:1,CourseCourseName:1,CourseId:1,CoursePrice:1,CourseSalePrice:1,DisplayOrder:1,Downloadable:1,DripContent:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,IsUserCompleted:1,LessonDescription:1,LessonFileType:1,LessonName:1,LessonType:1,OriginalFileStreamUrl:1,OriginalFileUploadUrl:1,S3FileUploadUrl:1,SectionId:1,SectionSectionName:1,Seo:1,UpdateDate:1,UpdateUserId:1,Volume:1},LmsCategory:{CategoryId:1,CategoryName:1,CategoryType:1,CoverImage:1,Description:1,DisplayOrder:1,Icon25x25:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,ParentCategoryCategoryName:1,ParentCategoryId:1,Seo:1,UpdateDate:1,UpdateUserId:1},LmsDocument:{Description:1,DisplayOrder:1,DocumentEntityType:1,DocumentName:1,DocumentType:1,EntityId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,OnlineViewer:1,UpdateDate:1,UpdateUserId:1},LmsPicture:{DisplayOrder:1,EntityId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Picture:1,PictureEntityType:1},LmsReview:{Comment:1,ConfirmDate:1,ConfirmUserId:1,EntityId:1,EntityItemName:1,EntityType:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Rate1:1,Rate2:1,Rate3:1,Rate4:1},LmsSection:{CourseCategoryId:1,CourseCourseDescription:1,CourseCourseName:1,CourseId:1,CoursePrice:1,CourseSalePrice:1,DisplayOrder:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,SectionContentCount:1,SectionDescription:1,SectionId:1,SectionName:1,UpdateDate:1,UpdateUserId:1},LmsTag:{EntityId:1,EntityType:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,Tag:1,UpdateDate:1,UpdateUserId:1},Neighbourhoods:{DistrictCityId:1,DistrictCode:1,DistrictId:1,DistrictName:1,Id:1,Name:1,PostCode:1},Order:{ConfirmDate:1,ConfirmUserId:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,ItemCount:1,OrderGuid:1,OrderId:1,OrderState:1},OrderItem:{AmountPaid:1,BundleCoverImage:1,BundleId:1,BundleThumbnail:1,CourseCoverImage:1,CourseId:1,CourseThumbnail:1,DeliveryFee:1,Discount:1,EntityId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,ItemCoverImage:1,ItemName:1,ItemPrice:1,ItemThumbnail:1,OrderConfirmDate:1,OrderConfirmUserId:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderItemEntityType:1,OrderOrderGuid:1,OrderOrderState:1,ProductCoverImage:1,ProductId:1,ProductThumbnail:1,Quantity:1,Tax:1,UsagePeriod:1,UserDisplayName:1,UserId:1},PricingPlan:{Capacity:1,Discount:1,EndDate:1,EntityId:1,EntityItemName:1,EntityType:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,PricingPlan:1,StartDate:1},Product:{CategoryCategoryName:1,CategoryId:1,Commission:1,CoverImage:1,DeliveryEstimatedTime:1,DeliveryFee:1,DemoVideo:1,DisplayOrder:1,EnableOrdering:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Inventory:1,InventoryWarning:1,IsActive:1,Price:1,ProductDescription:1,ProductId:1,ProductSummary:1,ProductTitle:1,ProductType:1,SellerId:1,Seo:1,SeoMetaDescription:1,Tax:1,Thumbnail:1,UnlimitedInventory:1,UpdateDate:1,UpdateUserId:1},ProductFilterItem:{FilterItemFilterId:1,FilterItemId:1,FilterItemInsertDate:1,FilterItemInsertUserId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,ProductId:1,ProductProductTitle:1},ProductSpecification:{Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,ProductId:1,ProductProductTitle:1,SpecificationId:1,SpecificationTitle:1},Quiz:{CertificateIncluded:1,CorrectAnswerCount:1,CourseCourseName:1,CourseId:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IsActive:1,NumberOfAttemps:1,PassMark:1,QuestionCount:1,QuizEndDate:1,QuizId:1,QuizStartDate:1,QuizStatus:1,QuizTitle:1,SectionId:1,SectionSectionName:1,Time:1,UpdateDate:1,UpdateUserId:1,UserGrade:1},QuizQuestion:{ChoiceA:1,ChoiceB:1,ChoiceC:1,ChoiceD:1,ChoiceE:1,CorrectAnswer:1,DisplayOrder:1,Grade:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,Question:1,QuizCourseId:1,QuizId:1,QuizIsActive:1,QuizNumberOfAttemps:1,QuizPassMark:1,QuizQuizTitle:1,QuizSectionId:1,QuizTime:1},Specification:{InputType:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,SpecificationId:1,Title:1},SpecificationCategory:{CategoryCategoryName:1,CategoryId:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,SpecificationId:1,SpecificationTitle:1},SpecificationItem:{Id:1,InputValue:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,SpecificationId:1,SpecificationTitle:1}},Logging:{LessonWatchLog:{AuthToken:1,CourseName:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IpNumber:1,LastSecond:1,LessonCourseId:1,LessonId:1,LessonLessonDescription:1,LessonLessonName:1,LessonLessonType:1,TotalSecond:1,UserAgent:1},LmsNotification:{Description:1,Id:1,InsertDate:1,IsRead:1,NotificationType:1,RelatedUserDisplayName:1,RelatedUserId:1},SmsSendLog:{Id:1,PhoneNumber:1,RelatedEntityId:1,RelatedEntityType:1,SendDate:1,SendSmsType:1,SenderUserId:1,SmsMessage:1,SmsMessageId:1,SmsResponse:1,SmsState:1,UserId:1},UserActivity:{AuthToken:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IpNo:1,UserActivityType:1,UserAgent:1,UserDisplayName:1,UserId:1,UserUsername:1},UserEventLog:{EntityId:1,EntityItemName:1,EntityType:1,EventType:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IpNumber:1},UserQuizAnswer:{Attempt:1,AuthToken:1,CorrectAnswer:1,Id:1,InsertDate:1,InsertUserDisplayName:1,InsertUserId:1,IpNumber:1,Question:1,QuestionChoiceA:1,QuestionChoiceB:1,QuestionChoiceC:1,QuestionChoiceD:1,QuestionChoiceE:1,QuestionCorrectAnswer:1,QuestionGrade:1,QuestionId:1,QuestionQuizId:1,UserAnswer:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}}) as any;
}
